module.exports = __webpack_public_path__ + "static/img/yes.08df8527.png";